import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-5 pt-5 border-t border-divider" }
const _hoisted_2 = { class: "flex items-center justify-center xl:mx-auto" }
const _hoisted_3 = { class: "flex rounded-full border border-muted overflow-hidden justify-center gap-1 px-1" }

import { useLangStore } from "@/stores/langStore";
import { useI18n } from "vue-i18n";
import { Lang } from "@/types/blogs";
import { onMounted } from "vue";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const { locale } = useI18n();

const langStore = useLangStore();

onMounted(() => {
  locale.value = langStore.current;
});

function toggleLang(l: Lang) {
  langStore.setLang(l);
  router.go(0);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full", 
            _unref(langStore).current === 'ru' ? 'bg-brown text-white' : 'text-brown'
          ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleLang('ru')))
        }, " РУ ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full", 
            _unref(langStore).current === 'en' ? 'bg-brown text-white' : 'text-brown'
          ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleLang('en')))
        }, " EN ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full", 
            _unref(langStore).current === 'uk' ? 'bg-brown text-white' : 'text-brown'
          ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleLang('uk')))
        }, " УКР ", 2)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ml-5 sf-pro-xs text-muted" }, "© 2025 Fengshui Style", -1))
    ])
  ]))
}
}

})